module.exports = __webpack_public_path__ + "img/log.891c914b.png";